import Vue from 'vue'
import VueWebCam from "vue-web-cam";

Vue.use(VueWebCam)
